import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useOfflineDownloadStatusStore } from './useOfflineDataDownloader/stores/offlineDownloadStatus/offlineDownloadStatus.store';

export const useOfflineDataDownloadInformation = () => {
  const { currentUserOfflineData, isUpdatingData } = useOfflineDownloadStatusStore(
    useShallow((state) => ({
      isUpdatingData: state.isUpdatingData,
      currentUserOfflineData: state.cachedData,
    })),
  );

  const totalSyncedPercentage = useMemo(() => {
    if (
      !currentUserOfflineData ||
      (!currentUserOfflineData.allKeys.length && !currentUserOfflineData.cachedKeys.length)
    ) {
      return 0;
    }

    const allKeys = currentUserOfflineData.allKeys.length;
    const cachedKeys = currentUserOfflineData.cachedKeys.length;

    const totalSyncedPercentage = Math.round((cachedKeys / allKeys) * 100);

    return totalSyncedPercentage;
  }, [
    currentUserOfflineData,
    currentUserOfflineData?.cachedKeys,
    currentUserOfflineData?.allKeys,
    isUpdatingData,
  ]);

  const hasSyncedData = totalSyncedPercentage === 100;
  const lastSyncedAt = currentUserOfflineData && currentUserOfflineData.lastSyncedAt;
  const isSyncing =
    isUpdatingData || (!!lastSyncedAt && !currentUserOfflineData.finishedDownloadAt);

  return {
    isSyncing,
    lastSyncedAt,
    hasSyncedData,
    totalSyncedPercentage,
  };
};
